import { isValidElement, cloneElement } from "react"
import { useTranslation } from "react-i18next"

// Helper to mirror styles for RTL
const mirrorStyle = (style = {}) => {
  const mirroredStyle = { ...style }

  // שומרים על textAlign: "center" בלי לשנות
  if (mirroredStyle.textAlign === "left") mirroredStyle.textAlign = "right"
  else if (mirroredStyle.textAlign === "right") mirroredStyle.textAlign = "left"
  // לא משנים אם זה center או משהו אחר

  if (mirroredStyle.marginLeft !== undefined) {
    mirroredStyle.marginRight = mirroredStyle.marginLeft
    delete mirroredStyle.marginLeft
  }
  if (mirroredStyle.marginRight !== undefined) {
    mirroredStyle.marginLeft = mirroredStyle.marginRight
    delete mirroredStyle.marginRight
  }

  if (mirroredStyle.paddingLeft !== undefined) {
    mirroredStyle.paddingRight = mirroredStyle.paddingLeft
    delete mirroredStyle.paddingLeft
  }
  if (mirroredStyle.paddingRight !== undefined) {
    mirroredStyle.paddingLeft = mirroredStyle.paddingRight
    delete mirroredStyle.paddingRight
  }

  return mirroredStyle
}

const useAutoTranslate = (children) => {
  const { t, i18n } = useTranslation()
  const isRTL = i18n.language === "he"
  const isHebrewChar = (char) => char >= "\u05D0" && char <= "\u05EA"

  const getDirectionFromText = (text) => {
    if (!text || typeof text !== "string") return "ltr" // ברירת מחדל
    const firstChar = text.trim()[0]
    return isHebrewChar(firstChar) ? "rtl" : "ltr"
  }
  const translateAndMirror = (node, indexForKey = 0) => {
    if (Array.isArray(node)) {
      return node.map((child, index) => {
        const translatedChild = translateAndMirror(child, index)
        if (isValidElement(translatedChild)) {
          return cloneElement(translatedChild, {
            key: translatedChild.key ?? index, // assign key if not present
          })
        }
        return translatedChild
      })
    }

    if (typeof node === "string") {
      const translatedText = t(node)
      const direction = getDirectionFromText(translatedText)

      // מחזיר תג div עם היישור והכיוון המתאימים
      return (
        <div
          key={indexForKey}
          dir={direction}
          style={{ direction, textAlign: direction === "rtl" ? "right" : "left" }}
        >
          {translatedText}
        </div>
      )
    }

    if (!isValidElement(node)) {
      return node
    }

    if (node.type?.muiName === "Rating") {
      return cloneElement(node, {
        ...node.props,
        dir: "ltr",
        style: {
          ...(node.props.style || {}),
          direction: "ltr",
        },
      })
    }

    const mirroredProps = { ...node.props }

    if (node.props.children) {
      mirroredProps.children = translateAndMirror(node.props.children)
    }

    if (node.props.style && typeof node.props.style === "object") {
      mirroredProps.style = {
        ...mirrorStyle(node.props.style),
        ...mirroredProps.style,
      }
    }

    mirroredProps.dir = isRTL ? "rtl" : "ltr"

    return cloneElement(node, mirroredProps)
  }

  return {
    translated: translateAndMirror(children),
    directionProps: {
      dir: isRTL ? "rtl" : "ltr",
      style: { direction: isRTL ? "rtl" : "ltr" },
    },
  }
}

export default useAutoTranslate
